"use client";

import { useEffect } from "react";
import { VStack } from "@astryxdesign/core/VStack";
import { Heading } from "@astryxdesign/core/Heading";
import { Text } from "@astryxdesign/core/Text";
import { Button } from "@astryxdesign/core/Button";
import { Card } from "@astryxdesign/core/Card";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <Card padding={8} width="100%" className="max-w-md">
        <VStack gap={4} align="start">
          <Heading level={2} type="display-3">
            Не удалось загрузить страницу
          </Heading>
          <Text color="secondary">
            Произошла ошибка при отображении. Попробуйте обновить страницу или
            вернитесь назад.
          </Text>
          <VStack gap={2} width="100%">
            <Button label="Обновить" variant="primary" onClick={() => reset()} />
            <Button
              label="Назад"
              variant="ghost"
              onClick={() => window.history.back()}
            />
          </VStack>
        </VStack>
      </Card>
    </div>
  );
}
